import { render, staticRenderFns } from "./LeavesStatisticsOverview.vue?vue&type=template&id=8b8b38ec"
import script from "./LeavesStatisticsOverview.vue?vue&type=script&lang=js"
export * from "./LeavesStatisticsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports